import React from 'react';

const MenuBar = ({toggleSidebar}) => {

  
  return (
    <div>
      {/* Step 3: Attach the toggleMenu function to an event (e.g., onClick) */}
      <img
        src="./Assets/menu-icon.png"
        className={`menu-icon`}
        onClick={toggleSidebar}
      />
    </div>
  );
};

export default MenuBar;
